// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".collapse-panel .collapse-panel-content[data-v-b882244a]{overflow:hidden;transition:height .3s;text-align:left}.collapse-panel .collapse-panel-fixed[data-v-b882244a]{display:flex;align-items:center;justify-content:left;border:1px solid #eaebee;padding:7px 0 7px 7px;cursor:pointer}.iconclass[data-v-b882244a]{transform:rotate(-90deg)}", ""]);
// Exports
module.exports = exports;
